// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__XQOJw","content":"styles_content__2h9di"};